import { Level } from './level';
import { LogHandler } from './log-handler';
import { LogRecord } from './log-record';

interface ConsoleHandlerOptions {
  useColor?: string;
}

export class ConsoleHandler extends LogHandler {
  constructor(private readonly options: ConsoleHandlerOptions = {}) {
    super();
  }

  publish(record: LogRecord): void {
    if (!this.isLoggable(record)) {
      return;
    }
    const loggingFn =
      record.level === Level.ERROR ? console.error : console.log;

    const prefix = this.options.useColor
      ? ['%c[%s]', `color: ${this.options.useColor};`, record.loggerName]
      : [`[${record.loggerName}]`];
    loggingFn(...prefix, ...record.messages);
  }
}
